import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import RegisterFlow1 from "components/RegisterFlow1";
import RegisterFlow2 from "components/RegisterFlow2";
import useUserProfile from "services/zustand/UserProfile";
import { Helmet } from "react-helmet";

const Submit = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status"); // Get the 'status' parameter
  const id = searchParams.get("id");
  const surveyName = searchParams.get("survey_name")
  const { setProfile } = useUserProfile();
  useEffect(() => {
    setProfile({ status: status, mtcRef: id, surveyName: surveyName  });
  }, [status, id, surveyName]);
  return (
    <>
      <Helmet>
        <title>Data Management</title>
        <meta name="title" content="Data Management" />
        <meta name="description" content="Data Management" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Data Management" />
        <meta property="og:description" content="Data Management" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Data Management" />
      </Helmet>
      <RegisterFlow2 />
      {/* {status === "complete" ? <RegisterFlow1 /> : <RegisterFlow2 />} */}
    </>
  );
};

export default Submit;
